import React from "react"

const PrivacyPolicyDisclaimer = () => (
    <div className="privacy-policy-disclaimer">
        <p>
            By clicking on the Submit button, you accept InFeedo <a href="https://www.infeedo.ai/website-terms">Terms & Conditions</a>.
            For more information on how we process your information, check out our{" "}
            <a href="https://www.infeedo.ai/privacy-policy/">Privacy Policy</a>.
        </p>
    </div>
)

export default PrivacyPolicyDisclaimer